import { groupClasses } from '../';

export default function (output) {
  if (!output || !output.financial_analytical_insight_factors) return [];

  const best = output.financial_analytical_insight_factors.best
    ? Object.keys(output.financial_analytical_insight_factors.best).map(
        (b) => ({
          title: b,
          cls: groupClasses.financial,
          value: output.financial_analytical_insight_factors.best[b]
        })
      )
    : [];
  const worst = output.financial_analytical_insight_factors.worst
    ? Object.keys(output.financial_analytical_insight_factors.worst).map(
        (b) => ({
          title: b,
          cls: groupClasses.financial,
          value: output.financial_analytical_insight_factors.worst[b]
        })
      )
    : [];

  return [
    {
      title: 'Financial & Analytical Insight',
      value: output.financial_analytical_insight,
      behavior_value: output.pan_result.financial_analytical_insight_score,
      cls: groupClasses.financial,
      header: true,
      admin: true
    },
    ...best,
    ...worst
    // {
    //   title: 'Knowledge',
    //   cls: groupClasses.financial,
    //   a: panResult.foobar,
    //   b: panResult.foobar
    // },
    // {
    //   title: 'Skill',
    //   cls: groupClasses.financial,
    //   a: panResult.foobar,
    //   b: panResult.foobar
    // },
    // {
    //   title: 'Behavior',
    //   cls: groupClasses.financial,
    //   a: panResult.foobar,
    //   b: panResult.foobar
    // },
    // {
    //   title: 'Customer Vision',
    //   cls: groupClasses.financial,
    //   a: panResult.foobar,
    //   b: panResult.foobar
    // },
    // {
    //   title: 'Focus',
    //   cls: groupClasses.financial,
    //   a: panResult.foobar,
    //   b: panResult.foobar
    // },
    // {
    //   title: 'Convergence',
    //   cls: groupClasses.financial,
    //   a: panResult.foobar,
    //   b: panResult.foobar
    // },
    // {
    //   title: 'Partnering',
    //   cls: groupClasses.financial,
    //   a: panResult.foobar,
    //   b: panResult.foobar
    // }
  ].map((m) => ({
    ...m,
    link:
      'https://louisianapacific.sharepoint.com/sites/LPSU/SitePages/Financial-&-Analytical-Insight-Courses.aspx'
  }));
}
